module.exports = __webpack_public_path__ + "img/2.8e339645.png";